export default {
  setProfile(state, data) {
    state.profile = data;
  },
  setPolls(state, data) {
    state.polls = data;
  },
  setPollById(state, data) {
    state.pollById = data;
  },
  setDashboard(state, data) {
    state.dashboard = data;
  },
  setConfig(state, data) {
    state.config = data;
  },
  setConfigForPanel(state, data) {
    state.configForPanel = data;
  },

  setFiles(state, data) {
    state.files = data;
  },
  setFile(state, data) {
    state.file = data;
  },
  setFileGrouping(state, data) {
    state.fileGrouping = data;
  },
  setFilesTime(state, data) {
    state.filesTime = data;
  },

  setBannerTypes(state, data) {
    state.bannerTypes = data;
  },
  setBanners(state, data) {
    state.banners = data;
  },
  setSliders(state, data) {
    state.sliders = data;
  },
  setSocialNetworks(state, data) {
    state.socialNetworks = data;
  },
  setSocialMedia(state, data) {
    state.socialMedia = data;
  },
  setMenus(state, data) {
    state.menus = data;
  },
  setMenu(state, data) {
    state.menu = data;
  },
  setPages(state, data) {
    state.pages = data;
  },
  setPage(state, data) {
    state.page = data;
  },
  setWidgets(state, data) {
    state.widgets = data;
  },
  setWidget(state, data) {
    state.widget = data;
  },
  setWidgetItems(state, data) {
    state.widgetItems = data;
  },

  setCategories(state, data) {
    state.categories = data;
  },
  setCategoryChilds(state, data) {
    state.categoryChilds = data;
  },

  setWaitingTickets(state, data) {
    state.waitingTickets = data;
  },
  setAnsweredTickets(state, data) {
    state.answeredTickets = data;
  },
  setClosedTickets(state, data) {
    state.closedTickets = data;
  },
  setTicket(state, data) {
    state.ticket = data;
  },
  setTicketCategories(state, data) {
    state.ticketCategories = data;
  },

  setUnits(state, data) {
    state.units = data;
  },

  setPosts(state, data) {
    state.posts = data;
  },
  setPost(state, data) {
    state.post = data;
  },
  setDeletePosts(state, data) {
    state.deletePosts = data;
  },

  setImages(state, data) {
    state.images = data;
  },
  setImage(state, data) {
    state.image = data;
  },
  setDeletedImages(state, data) {
    state.deletedImages = data;
  },

  setVideos(state, data) {
    state.videos = data;
  },
  setVideo(state, data) {
    state.video = data;
  },
  setDeletedVideos(state, data) {
    state.deletedVideos = data;
  },

  setSounds(state, data) {
    state.sounds = data;
  },
  setSound(state, data) {
    state.sound = data;
  },
  setDeletedSounds(state, data) {
    state.deletedSounds = data;
  },

  setUseless(state, data) {
    state.useless = data;
  },
  setApprovedComments(state, data) {
    state.approvedComments = data;
  },
  setUnapprovedComments(state, data) {
    state.unapprovedComments = data;
  },
  setComment(state, data) {
    state.comment = data;
  },

  setColors(state, data) {
    state.colors = data;
  },

  setPackings(state, data) {
    state.packings = data;
  },

  setPackingInfo(state, data) {
    state.packingInfo = data;
  },

  setDesignTypes(state, data) {
    state.designTypes = data;
  },

  setCommodities(state, data) {
    state.commodities = data;
  },
  setMachines(state, data) {
    state.machines = data;
  },

  setTemplates(state, data) {
    state.templates = data;
  },
  setProductPrice(state, data) {
    state.productPrice = data;
  },
  setBenefitsAndDeduction(state, data) {
    state.benefitsAndDeduction = data;
  },

  setFiscalYear(state, data) {
    state.fiscalYear = data;
  },

  setBoms(state, data) {
    state.boms = data;
  },
  setBom(state, data) {
    state.bom = data;
  },

  setWorkCalender(state, data) {
    state.workCalender = data;
  },

  setAnnualBase(state, data) {
    state.annualBase = data;
  },

  setUnitPosition(state, data) {
    state.unitPosition = data;
  },

  setJobs(state, data) {
    state.Jobs = data;
  },

  setBanks(state, data) {
    state.banks = data;
  },

  setAccountInfo(state, data) {
    state.accountInfo = data;
  },
  setTreeAccountInfo(state, data) {
    state.treeAccountInfo = data;
  },

  setTaxs(state, data) {
    state.taxs = data;
  },

  setInputOutputs(state, data) {
    state.inputOutputs = data;
  },

  setCompanyInfo(state, data) {
    state.companyInfo = data;
  },

  setMeasurementUnits(state, data) {
    state.measurementUnits = data;
  },
  setPosters(state, data) {
    state.posters = data;
  },
  setPositions(state, data) {
    state.positions = data;
  },
  setCars(state, data) {
    state.cars = data;
  },
  setCar(state, data) {
    state.car = data;
  },
  setSaleTypes(state, data) {
    state.saleTypes = data;
  },
  setSaleType(state, data) {
    state.saleType = data;
  },
  setTransactions(state, data) {
    state.transactions = data;
  },
  setFactors(state, data) {
    state.factors = data;
  },
  setFinishFactors(state, data) {
    state.finishFactors = data;
  },

  setOrdersSettings(state, data) {
    state.ordersSettings = data;
  },
};
